var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentList',{attrs:{"type":_vm.statuses_.rejected}})}
var staticRenderFns = []

export { render, staticRenderFns }